import axios from "axios";
import { signOut } from "next-auth/react";

export const fetcher = async (url: string, queryParams = "") => {
  if (localStorage.getItem("correlationId")) {
    axios.defaults.headers.common["correlation-id"] =
      localStorage.getItem("correlationId");
    axios.defaults.headers.common["x-cloud-trace-context"] =
      localStorage.getItem("correlationId");
  }
  const axiosInstance = axios.create({
    headers: {
      "correlation-id": localStorage.getItem("correlationId"),
      "x-cloud-trace-context": localStorage.getItem("correlationId"),
    },
  });
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.status === 401) {
        await signOut({ callbackUrl: "/login?msg=session_expired" });
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
  const res = await axiosInstance.get(`${url}${queryParams}`);
  return res.data;
};

export const clientAxiosInstance = () => {
  if (localStorage.getItem("correlationId")) {
    axios.defaults.headers.common["correlation-id"] =
      localStorage.getItem("correlationId");
    axios.defaults.headers.common["x-cloud-trace-context"] =
      localStorage.getItem("correlationId");
  }
  const axiosInstance = axios.create({
    headers: {
      "correlation-id": localStorage.getItem("correlationId"),
      "x-cloud-trace-context": localStorage.getItem("correlationId"),
    },
  });
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.status === 401) {
        await signOut({ callbackUrl: "/login?msg=session_expired" });
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};
